import CommonManager from '../../helpers/common';
const commonManager = new CommonManager();
const { v4: uuidv4 } = require('uuid');

const buildMessage = ( input, noUserId ) => {
  let taskId = uuidv4();
  let userId = input.userId || commonManager.getUserId();
  let body = input.body || {};
  if( !noUserId ){
    body.userId = userId;
  }
  return {
    pattern: input.pattern,
    type: input.type,
    requestFrom: `user`,
    data: {
      priority: input.priority || 1,
      text: {
        header: {
          'X-TENANT-ID': input.tenantId || commonManager.getTenant()
        },
        body: input.body || {},
        subtype: input.subtype || '',
        taskId: taskId,
        userId: userId
      },
      mainType: input.mainType || '',
      subtype: input.subtype || '',
      taskId: taskId,
      replayTo: input.replayTo || 'call-service',
      userId: userId
    },
    userId: userId
  };
};
export { buildMessage };



// WEBPACK FOOTER //
// src/store/helper/call.helper.js